import { useState } from "react"

import { useUnits } from "web/hooks/data"
import { Button, Form, Field, ErrorMessage } from "web/components"
import { sortByKey, valueFromPlainObject } from "web/services/helpers"
import { humanize, titleize } from "web/services/inflector"

const DEFAULT_OPTION = { value: "__DEFAULT", label: "Default" }

export default function UnitSettings({
  close,
  handleUpdateUnits,
  currencyCode,
  areaUnitCode,
  lengthUnitCode,
  distanceUnitCode,
}) {
  const [
    {
      area_units: areaUnits,
      distance_units: distanceUnits,
      length_units: lengthUnits,
      currencies,
    },
  ] = useUnits()

  const [error, setError] = useState("")

  async function handleFormSubmit(value) {
    const { currency, area_unit, length_unit, distance_unit } = value

    const newCurrency = currency?.value
    const newAreaUnit = area_unit?.value
    const newLengthUnit = length_unit?.value
    const newDistanceUnit = distance_unit?.value

    const update = {
      currencyCode: newCurrency === DEFAULT_OPTION.value ? null : newCurrency,
      areaUnitCode: newAreaUnit === DEFAULT_OPTION.value ? null : newAreaUnit,
      lengthUnitCode:
        newLengthUnit === DEFAULT_OPTION.value ? null : newLengthUnit,
      distanceUnitCode:
        newDistanceUnit === DEFAULT_OPTION.value ? null : newDistanceUnit,
    }

    try {
      setError("")
      await handleUpdateUnits(update)
      close()
    } catch {
      setError(
        "Unable to update settings, please try again or contact suppport"
      )
    }
  }

  const lookupValues = [currencies, areaUnits, lengthUnits, distanceUnits].map(
    (units) =>
      [DEFAULT_OPTION].concat(
        sortByKey(
          units.map((c) => ({ value: c.code, label: c.name })),
          "label"
        )
      )
  )

  const fields = ["currency", "area_unit", "length_unit", "distance_unit"].map(
    (unitType, index) => ({
      name: unitType,
      key: unitType,
      label: titleize(humanize(unitType)),
      kind: "Lookup",
      lookup_values: lookupValues[index],
      required: true,
    })
  )

  return (
    <Form
      value={valueFromPlainObject(
        {
          currency: currencyCode || DEFAULT_OPTION.value,
          area_unit: areaUnitCode || DEFAULT_OPTION.value,
          length_unit: lengthUnitCode || DEFAULT_OPTION.value,
          distance_unit: distanceUnitCode || DEFAULT_OPTION.value,
        },
        fields
      )}
      fields={fields}
      onSubmit={handleFormSubmit}
      render={(form) => {
        return (
          <>
            <div className="modal-content-above-commands">
              <div className="space-y-6">
                <Field fieldKey="currency" sortSuggestions={false} />
                <Field fieldKey="area_unit" sortSuggestions={false} />
                <Field fieldKey="length_unit" sortSuggestions={false} />
                <Field fieldKey="distance_unit" sortSuggestions={false} />
              </div>
            </div>
            <div className="modal-commands">
              {error && (
                <div className="mt-3">
                  <ErrorMessage message={error} />
                </div>
              )}
              <div className="left-buttons">
                <Button
                  onClick={form.submit}
                  disabled={!form.isValid}
                  disableAfterClick
                >
                  Save Settings
                </Button>
              </div>
            </div>
          </>
        )
      }}
    />
  )
}
